import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-neutral-100" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "max-w-lg min-h-[calc(100vh-250px)] mx-auto text-center" }
const _hoisted_4 = {
  class: "text-base flex flex-col items-center justify-center min-h-screen",
  autocomplete: "off"
}
const _hoisted_5 = { class: "mt-8 mb-20 text-center max-w-full h-20 w-[500px] text-neutral-800" }

import { useRouter } from 'vue-router';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import DomainSearch from '@/components/DomainSearch.vue';
import MetaTags from '@/components/MetaTags.vue';
import AdUnit from '@/components/ads/AdUnit.vue';
import { domainNameToUrlPath } from '@/common/domainName';
import { ReverseIpLookup } from '@/common/adSlots';


export default /*@__PURE__*/_defineComponent({
  __name: 'ReverseIpLookup',
  setup(__props) {

const router = useRouter();

function redirectTo(ip: string): void {
  router.push(`/ip/${domainNameToUrlPath(ip)}/domain-names/`);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "Reverse IP Lookup",
        description: "Find the domain name that is connected to an IP address. Check if the any websites are hosted on an IP by doing a reverse DNS lookup.",
        url: "https://www.nslookup.io/reverse-ip-lookup/"
      })
    ])),
    _createVNode(HeaderComponent, {
      "domain-search-to-url": (encodedDomain) => `/ip/${encodedDomain}/domain-names/`,
      "search-button-text": "Reverse lookup",
      "autocomplete-enabled": false
    }, null, 8, ["domain-search-to-url"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "font-extrabold text-4xl max-w-full my-8" }, "Reverse IP lookup", -1)),
            _createVNode(DomainSearch, {
              class: "h-12 mb-6 max-w-full w-[500px]",
              autofocus: "",
              emphasize: "",
              "autocomplete-enabled": false,
              buttonText: "Reverse lookup",
              "placeholder-text": "IP address",
              onSubmitted: redirectTo
            }),
            _createElementVNode("p", _hoisted_5, [
              _cache[2] || (_cache[2] = _createTextVNode("Find the domain name that is connected to an IP address. Check if the any websites are hosted on an IP by doing a reverse DNS lookup.", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
              _cache[4] || (_cache[4] = _createTextVNode("For example, try ", -1)),
              _createVNode(_component_router_link, {
                to: "/ip/91.198.174.192/domain-names/",
                title: "Domain names for 91.198.174.192",
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("91.198.174.192", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" or ", -1)),
              _createVNode(_component_router_link, {
                to: "/ip/1.1.1.1/domain-names/",
                title: "Domain names for 1.1.1.1",
                class: "text-blue-600 hover:text-blue-800 hover:underline"
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("1.1.1.1", -1)
                ]))]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" to view their domain names. ", -1))
            ]),
            _createVNode(AdUnit, {
              class: "mt-8 mx-auto",
              config: _unref(ReverseIpLookup)
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})